module.exports = __webpack_public_path__ + "img/demonstration-phone-bar.8eed30e8.png";